import config from '@/config';
import { ApiBase, InternationalizedField } from '@/api/common';
import { isNil } from 'lodash';
import axios, { AxiosResponse } from 'axios';
import store from '@/store';

const NO_UPLOAD_FIELDS = ['audio_link', 'audio_alt_link', 'image_link'];

export default class ListeningItem extends ApiBase<ListeningItem> {
  public static readonly SLUG: string = 'exercise-listening-item';
  private static readonly URL_BASE: string =
    config.API_ROOT + '/exercise-listening-item/';

  // Initializing these fields (even with undefined)
  // is necessary, so hasOwnAttribute can find them.
  public audio_path?: number = undefined;
  public audio_link?: string = undefined;
  public audio_alt_path?: number = undefined;
  public audio_alt_link?: string = undefined;
  public image_path?: number = undefined;
  public image_link?: string = undefined;
  public index?: number = undefined;
  public sentence?: string = undefined;
  public transcription?: string = undefined;
  public order?: number = undefined;
  public parent_exercise?: number = undefined;
  public sentence_i18n: InternationalizedField<string> = new InternationalizedField<string>();

  // currently unused
  public spreadsheet?: string = undefined;

  public constructor(index?: number) {
    super({
      urlBase: ListeningItem.URL_BASE,
      filteredFields: NO_UPLOAD_FIELDS
    });
    this.index = index;
  }

  public assign(response: any): ListeningItem {
    super.assign(response);

    if (response) {
      if ('sentence_i18n' in response) {
        this.sentence_i18n = new InternationalizedField<string>(
          response.sentence_i18n
        );
      }
    }

    return this;
  }

  public async checkAudioText(item: ListeningItem) {
    let ts = Date.now().toString();
    let bodyFormData = new FormData();

    bodyFormData.append('sentence', item.sentence);
    bodyFormData.append('ts', ts.substring(0, ts.length - 3));

    if (!isNil(item.audio_path)) {
      const _response: AxiosResponse<any> = await axios({
        method: 'GET',
        url: config.API_ROOT + '/media-audio/' + item.audio_path,
        data: bodyFormData,
        headers: {
          'X-Session': store.state.sessionToken
        }
      });
      bodyFormData.append('packet_file', _response.data.public_url);
    }

    const response: AxiosResponse<any> = await axios({
      method: 'POST',
      url: config.API_ROOT + '/reference-score/',
      data: bodyFormData,
      headers: {
        'X-Session': store.state.sessionToken
      }
    });
    if (response && response.data.reference_score.success !== false) {
      return response.data.reference_score;
    }
  }
}
